import React from "react";
import Box from "@mui/material/Box";

export default function AppBackground({ children, sx, ...rest }) {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        px: 2,
        pt: 3,
        pb: 10,
        backgroundImage: `
          radial-gradient(circle at 20% 10%, rgba(236,72,153,0.10), transparent 40%),
          radial-gradient(circle at 80% 0%, rgba(139,92,246,0.14), transparent 45%),
          linear-gradient(180deg, rgba(8,7,14,0.22), rgba(8,7,14,0.82)),
          url("/assets/bg-pitchest.jpg")
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}